import { IProjectStatus } from './generated-types/project-status'
import { MUIThemeColors } from './mui-theme'

export const languages = ['en', 'no']

/** ISO 4217 + BCP 47 locale for currency amounts in license billing UI */
export const LICENSE_BILLING_CURRENCY_CODE = 'NOK'
export const LICENSE_BILLING_CURRENCY_LOCALE = 'nb-NO'

/** Mirrors WebApi.Services.LicensePricing — used when usage API omits per-type unit rates */
export const LICENSE_SYSTEM_DEFAULT_LOCALITY_MONTHLY = 1739
export const LICENSE_SYSTEM_DEFAULT_SERVICE_STATION_MONTHLY = 4200
export const LICENSE_SYSTEM_DEFAULT_STORAGE_MONTHLY = 500
export const NO_VALID_CERTIFICATE = 'NoValidCertificate'
export const MainComponentStatus = {
  Active: 'Active',
  InService: 'In Service',
  InStorage: 'In Storage',
}
export const NOT_FOUND = 'NotFound'
export const SUCCESSFULLY_DELETED = 'SuccessfullyDeleted'
export const SUCCESSFULLY_REMOVED = 'SuccessfullyRemoved'
export const SUCCESSFULLY_ADDED = 'SuccessfullyAdded'
export const SUCCESSFULLY_CREATED = 'SuccessfullyCreated'
export const SUCCESSFULLY_UPDATED = 'SuccessfullyUpdated'
export const SUCCESSFULLY_APPROVED = 'SuccessfullyApproved'
export const SUCCESSFULLY_WITHDREW = 'SuccessfullyWithdrew'
export const INTERNAL_SERVER_ERROR = 'InternalError'
export const ALREADY_EXISTS = 'AlreadyExists'
export const COMPONENT_EXISTS = 'ComponentsExists'
export const CANNOT_DELETE = 'CannotDelete'
export const CANNOT_ADD = 'CannotAdd'
export const POSITIONS_EXIST = 'PositionsExist'
export const LIMIT_EXCEEDED = 'LimitExceeded'
export const CANNOT_DISCARD = 'CannotDiscard'
export const SAME_RULE_ERROR = 'SameRuleError'
export const RULE_RELEASED = 'RuleReleased'
export const RULES_RESTORED = 'RulesRestored'
export const RULES_MERGED = 'RulesMerged'
export const INVALID_END_DATE = 'InvalidEndDate'
export const REPORTS_NOT_COMPLETED = 'ReportsNotCompleted'
export const POSITIONS_CONNECTED_TO_OTHER_POSITIONS = 'PositionConnectedToOtherPositions'
export const CONNECTED_POSITIONS_EXIST = 'ConnectedPositionsExist'
export const DEVIATION_NOT_FOUND = 'DeviationNotFound'
export const INVALID_COMPLETE_DATE = 'WRONG_COMPLETED_DATE'
export const INVALID_RESCHEDULE_DATE = 'WRONG_RESCHEDULE_DATE'
export const POSITION_HAS_EQUIPMENT = 'PositionHasEquipment'
export const DUPLICATE_COMPONENT = 'DuplicateComponent'

export const CUSTOM_PROPERTY_LABELS = {
  CIRCUMFERENCE: 'Circumference',
  PIPE_DIAMETER: 'PipeDiameter',
  LIFE_TIME: 'LifeTime',
  PERIMETER: 'Perimeter',
}

export const WorkAssignmentReportType = {
  1: 'UTLEGGSRAPPORT',
  2: 'FORANKRING INSPEKSJONSRAPPORT',
  3: 'AQS - UTLEGGSRAPPORT',
  4: 'AQS - FORANKRING INSPEKSJONSRAPPORT',
  5: '6 MÅNEDERS KONTROLL',
  6: '12 MÅNEDERS KONTROLL',
  7: '5 ÅRS KONTROLL',
  8: '5 ÅRS KONTROLL m/komponenter',
}
export const APIResultCount = {
  Less: 10,
  More: 1000,
  Max: 100000,
}

export const DiscardComponentId = Math.floor(Math.random() * 1000000000)

export const QuickFilterBounceTime = 500

export const permissionLevel = {
  Locality: ['Read', 'Update'],
  Deviation: ['Read', 'Write', 'Update'],
  Documents: ['Read', 'Write', 'Delete'],
  Service: ['Read', 'Write', 'Update'],
  Task: ['Read', 'Write', 'Update'],
  Mooring: ['Write', 'Delete'],
  Mooring_Deviation: ['Read'],
  MainComponent: ['Read'],
  MainComponent_Deviation: ['Read', 'Write', 'Delete'],
  MainComponent_Document: ['Read', 'Write', 'Delete'],
  MainComponent_Certification: ['Read', 'Write', 'Delete'],
  MainComponent_Report: ['Read', 'Write', 'Delete'],
  WorkAssignment: ['Read', 'Write', 'Delete'],
  ServiceStation: ['Read', 'Write', 'Update', 'Delete'],
  Storage: ['Read', 'Write', 'Update', 'Delete'],
  Maintenance: ['Delete', 'Perform'],
  Position: ['Write'],
  News: ['Read', 'Write', 'Delete'],
  ClientAdminPermission: ['Read'],
  ProjectPlanning: ['Read', 'Write', 'Update', 'Delete'],
  Equipment_Portal: ['Read'],
  Task_Portal: ['Read'],
}

export const permissionBinding = {
  Locality: { Update: ['Locality.Read'] },
  Deviation: {
    Read: ['Locality.Read'],
    Write: ['Deviation.Read', 'Locality.Read'],
    Update: ['Deviation.Read', 'Locality.Read'],
  },
  Documents: {
    Read: ['Locality.Read'],
    Write: ['Documents.Read', 'Locality.Read'],
    Delete: ['Documents.Read', 'Locality.Read'],
  },
  Service: {
    Read: ['Locality.Read'],
    Write: ['Service.Read', 'Locality.Read'],
    Update: ['Service.Read', 'Locality.Read'],
  },
  Task: { Read: ['Locality.Read'], Write: ['Task.Read', 'Locality.Read'], Update: ['Task.Read', 'Locality.Read'] },
  Mooring_Deviation: { Read: ['Locality.Read'] },
  Mooring: { Write: ['Locality.Read'], Delete: ['Locality.Read'] },
  MainComponent: { Read: ['Locality.Read'] },
  Position: { Write: ['Locality.Read'] },
  MainComponent_Deviation: {
    Read: ['Locality.Read'],
    Write: ['MainComponent_Deviation.Read', 'MainComponent.Read', 'Locality.Read'],
    Delete: ['MainComponent_Deviation.Read', 'MainComponent.Read', 'Locality.Read'],
  },
  MainComponent_Document: {
    Read: ['Locality.Read'],
    Write: ['MainComponent_Document.Read', 'MainComponent.Read', 'Locality.Read'],
    Delete: ['MainComponent_Document.Read', 'MainComponent.Read', 'Locality.Read'],
  },
  MainComponent_Certification: {
    Read: ['Locality.Read'],
    Write: ['MainComponent_Certification.Read', 'MainComponent.Read', 'Locality.Read'],
    Delete: ['MainComponent_Certification.Read', 'MainComponent.Read', 'Locality.Read'],
  },
  MainComponent_Report: {
    Read: ['Locality.Read'],
    Write: ['MainComponent_Report.Read', 'MainComponent.Read', 'Locality.Read'],
    Delete: ['MainComponent_Report.Read', 'MainComponent.Read', 'Locality.Read'],
  },
  WorkAssignment: {
    Read: ['Locality.Read'],
    Write: ['WorkAssignment.Read', 'Locality.Read'],
    Delete: ['WorkAssignment.Read', 'Locality.Read'],
  },
  ServiceStation: {
    Write: ['ServiceStation.Read'],
    Update: ['ServiceStation.Read'],
    Delete: ['ServiceStation.Read'],
  },
  Maintenance: {
    Read: ['Locality.Read'],
    Perform: ['Maintenance.Read', 'Locality.Read'],
    Delete: ['Maintenance.Read', 'Locality.Read'],
  },
  Storage: {
    Write: ['Storage.Read'],
    Update: ['Storage.Read'],
    Delete: ['Storage.Read'],
  },
  News: {
    Read: ['Locality.Read'],
    Write: ['News.Read', 'Locality.Read'],
    Delete: ['News.Read', 'Locality.Read'],
  },
}

export const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/

export const pageSizes = [5, 10, 20]

export const CageConfig = {
  OFFSET_START: 901,
  OFFSET_END: 1000,
  ASCII_START_VALUE: 65,
  CAGE_TYPE: 5,
}

export enum TableActionTypes {
  KebabMenu = 'kebabMenu',
  Inline = 'inline',
}

export const projectStatusColors = {
  [IProjectStatus.InProcess]: MUIThemeColors.primaryLight,
  [IProjectStatus.OnHold]: MUIThemeColors.warningLight,
  [IProjectStatus.Published]: MUIThemeColors.successMain,
  [IProjectStatus.Cancelled]: MUIThemeColors.errorMain,
}
export const DefaultSupplierID = '877 059 022'

